(() => {
  const SOURCE = 'sportszone-flyti-inventory';
  const PACKAGE_PROP = '_SportsZone FLY-TI package';
  const PARENT_KEY_PROP = '_SportsZone FLY-TI parent key';
  const COMPONENT_PROP = '_SportsZone FLY-TI component';
  const COMPONENT_VALUE = 'BAUER FLY-TI runner';
  const ELIGIBLE = new Set([15242199433580,15242199466348,15242199499116,15242199531884,15242360258924,15242360652140,15242360684908,15242360717676,15245454475628,15242326507884,15242326704492,15242326475116,15242326671724]);
  const originalFetch = window.fetch.bind(window);
  let variantsPromise = null;
  let syncPromise = null;
  let queued = false;

  const rootUrl = () => window.Shopify?.routes?.root || '/';
  const pathOf = (input) => {
    const value = typeof input === 'string' || input instanceof URL ? String(input) : String(input?.url || '');
    try { return new URL(value, location.origin).pathname; } catch (_error) { return value.split('?')[0]; }
  };
  const isAdd = (input) => /\/cart\/add(?:\.js)?\/?$/.test(pathOf(input));
  const isMutation = (input) => /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(pathOf(input));
  const idNum = (value) => Number(String(value || '').match(/(\d+)$/)?.[1] || 0);
  const props = (line) => line?.properties && typeof line.properties === 'object' ? line.properties : {};
  const isRegularTi = (properties) => properties?.['Steel choice'] === 'BAUER FLY-TI' && properties?.['Steel package'] === 'Included with regular skate package';
  const isParent = (line) => ELIGIBLE.has(Number(line?.product_id || 0)) && isRegularTi(props(line));
  const holder = (value) => Number.parseInt(String(value || '').split('/')[0].replace(/[^\d]/g, ''), 10) || 0;
  const variantHolder = (variant) => Number.parseInt(String(variant?.title || '').replace(/[^\d]/g, ''), 10) || 0;
  const normalize = (variant) => ({ ...variant, id: idNum(variant?.id), available: variant?.available !== false });

  const variants = async () => {
    const node = document.querySelector('[data-sz-fly-ti-variants]');
    try {
      const local = JSON.parse(node?.textContent || '[]');
      if (Array.isArray(local) && local.length) return local.map(normalize);
    } catch (_error) {}
    if (!variantsPromise) {
      variantsPromise = originalFetch(`${rootUrl()}products/bauer-fly-ti-hockey-skate-runners.js`, { credentials:'same-origin', headers:{Accept:'application/json'} })
        .then(async (response) => {
          if (!response.ok) throw new Error('Could not load BAUER FLY-TI runners.');
          const product = await response.json();
          return (product?.variants || []).map(normalize);
        })
        .catch((error) => { variantsPromise = null; throw error; });
    }
    return variantsPromise;
  };

  const findRunner = async (runnerSize) => {
    const h = holder(runnerSize);
    if (!h) return null;
    return (await variants()).find((variant) => variantHolder(variant) === h) || null;
  };

  const packageKey = (main, runnerId) => props(main)[PACKAGE_PROP] || `flyti-${idNum(main?.id)}-${runnerId}-${Date.now()}-${Math.random().toString(36).slice(2,7)}`;
  const parentTitle = () => document.querySelector('[data-sz-steel-choice]')?.dataset?.parentTitle || 'Configured BAUER skate';
  const runnerProps = (mainProps, key, parentKey = '') => ({
    'Runner for': parentTitle(),
    'Matched runner size': mainProps['Runner size'] || '',
    'Steel package': 'FLY-TI package runner — price adjusted with skate',
    ...(key ? { [PACKAGE_PROP]: key } : { [PARENT_KEY_PROP]: parentKey }),
    [COMPONENT_PROP]: COMPONENT_VALUE,
  });

  const inject = async (payload) => {
    if (!Array.isArray(payload?.items)) return false;
    let changed = false;
    for (const main of [...payload.items]) {
      const mainProps = { ...props(main) };
      if (!isRegularTi(mainProps)) continue;
      const runner = await findRunner(mainProps['Runner size']);
      if (!runner?.id || runner.available === false) throw new Error('The matched BAUER FLY-TI runner is unavailable for this skate size.');
      const key = packageKey(main, runner.id);
      mainProps[PACKAGE_PROP] = key;
      main.properties = mainProps;
      if (!payload.items.some((item) => idNum(item?.id) === runner.id && props(item)[PACKAGE_PROP] === key)) {
        payload.items.push({ id: runner.id, quantity: Math.max(1, Number(main.quantity || 1)), properties: runnerProps(mainProps, key) });
      }
      changed = true;
    }
    return changed;
  };

  const fetchCart = async () => {
    const response = await originalFetch(`${rootUrl()}cart.js`, { credentials:'same-origin', headers:{Accept:'application/json'} });
    if (!response.ok) throw new Error('Could not read cart.');
    return response.json();
  };
  const changeLine = async (key, quantity) => {
    const response = await originalFetch(`${rootUrl()}cart/change.js`, { method:'POST', credentials:'same-origin', headers:{Accept:'application/json','Content-Type':'application/json'}, body:JSON.stringify({id:key,quantity}) });
    const cart = await response.json();
    if (!response.ok || cart?.status) throw new Error(cart?.description || 'Could not synchronize FLY-TI runner quantity.');
    return cart;
  };
  const addRunner = async (parent, runner) => {
    const p = props(parent);
    const packageId = p[PACKAGE_PROP] || '';
    const properties = { ...runnerProps(p, packageId, parent.key), 'Runner for': `${parent.product_title || 'Configured BAUER skate'}${parent.variant_title ? ` — ${parent.variant_title}` : ''}` };
    const response = await originalFetch(`${rootUrl()}cart/add.js`, { method:'POST', credentials:'same-origin', headers:{Accept:'application/json','Content-Type':'application/json'}, body:JSON.stringify({items:[{id:runner.id,quantity:Math.max(1,Number(parent.quantity || 1)),properties}]}) });
    const data = await response.json();
    if (!response.ok || data?.status) throw new Error(data?.description || 'Could not add the matched FLY-TI runner.');
  };

  const sync = async () => {
    if (syncPromise) return syncPromise;
    syncPromise = (async () => {
      let cart = await fetchCart();
      const parents = (cart.items || []).filter(isParent);
      const parentKeys = new Set(parents.map((item) => item.key));
      const packageIds = new Set(parents.map((item) => props(item)[PACKAGE_PROP]).filter(Boolean));
      let changed = false;
      for (const component of (cart.items || []).filter((item) => props(item)[COMPONENT_PROP] === COMPONENT_VALUE)) {
        const p = props(component);
        const orphan = p[PACKAGE_PROP] ? !packageIds.has(p[PACKAGE_PROP]) : p[PARENT_KEY_PROP] ? !parentKeys.has(p[PARENT_KEY_PROP]) : true;
        if (orphan) { cart = await changeLine(component.key, 0); changed = true; }
      }
      if (changed) cart = await fetchCart();
      for (const parent of (cart.items || []).filter(isParent)) {
        const p = props(parent);
        const runner = await findRunner(p['Runner size']);
        if (!runner?.id || runner.available === false) continue;
        const linked = (cart.items || []).find((item) => {
          const ip = props(item);
          if (ip[COMPONENT_PROP] !== COMPONENT_VALUE) return false;
          if (p[PACKAGE_PROP] && ip[PACKAGE_PROP] === p[PACKAGE_PROP]) return true;
          return ip[PARENT_KEY_PROP] === parent.key;
        });
        if (!linked) { await addRunner(parent, runner); cart = await fetchCart(); changed = true; }
        else if (idNum(linked.variant_id || linked.id) !== runner.id) { await changeLine(linked.key, 0); await addRunner(parent, runner); cart = await fetchCart(); changed = true; }
        else if (Number(linked.quantity || 0) !== Number(parent.quantity || 0)) { cart = await changeLine(linked.key, Number(parent.quantity || 0)); changed = true; }
      }
      if (changed && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:SOURCE,cartData:cart});
      window.setTimeout(() => window.SportsZoneFlyTiPackage?.syncDiscount?.(), 25);
      return cart;
    })().catch((error) => console.error('SportsZone FLY-TI inventory sync error', error)).finally(() => { syncPromise = null; });
    return syncPromise;
  };
  const schedule = (delay=25) => { if (queued) return; queued=true; setTimeout(() => {queued=false;sync();},delay); };

  window.fetch = async (input, options={}) => {
    if (isAdd(input) && typeof options?.body === 'string') {
      try {
        const payload = JSON.parse(options.body);
        if (await inject(payload)) {
          const response = await originalFetch(input,{...options,body:JSON.stringify(payload)});
          schedule(20);
          return response;
        }
      } catch (error) {
        if (error instanceof SyntaxError) {} else { console.error('SportsZone FLY-TI cart guard error', error); throw error; }
      }
    }
    const response = await originalFetch(input,options);
    if (isMutation(input)) schedule(30);
    return response;
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate,(event)=>{if(event?.source!==SOURCE)schedule(35);});
  window.SportsZoneFlyTiInventory = { sync };
  setTimeout(() => schedule(0),500);
})();
